




























import Vue, { PropOptions } from 'vue';
import SLoadingAnim from '../SLoadingAnim/SLoadingAnim.vue';

/**
 * Page loading animation component wrapper
 */
export default Vue.extend({
  name: 'SPageLoading',
  components: {
    SLoadingAnim,
  },
  props: {
    /**
     * The text that will be displayed along with the loading animation
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * If the loader should be visible
     */
    loading: {
      type: Boolean,
      required: true,
    },
    /**
     * DEPRECATED
     * Classnames to be applied to the container element for both loading states
     */
    containerClasses: {
      type: Array,
      required: false,
      validator(): boolean {
        console.warn('SPageLoading: The \'containerClasses\' prop is deprecated, please use \'class\'');
        return true;
      },
    } as PropOptions<string[]>,
    /**
     * If a progress number is provided we will show a loading bar with the progress.
     * The max value is assumed to be 100
     */
    progress: {
      type: Number,
      required: false,
      default: null,

    },
  },
  computed: {
    classNames(): string[] {
      const containerClasses = this.containerClasses || [];
      return [
        this.loading ? 'is-loading' : '',
        this.loading ? 'pa-12' : '',
        ...containerClasses,
      ];
    },
    showLoadingBar(): boolean {
      return this.loading && this.progress !== null;
    },
  },
});
